import type { IJobAssociatedMaintenancePart } from '@/interfaces'
import type { IDecimalValueAndUnit } from '@/interfaces/IDecimalValueAndUnit'

class JobAssociatedMaintenancePart implements IJobAssociatedMaintenancePart {
  title: string

  workHours: number

  constructor(part?: any) {
    this.title = part?.title
    this.workHours = part?.workHours
  }
}

export default JobAssociatedMaintenancePart
